//Styles
import Styles from "./WindowOptions.module.scss";
import classnames from "classnames"


interface WindowOptionsProps{
  onClickCLoseWindow:()=>void;
}

const WindowOptions = ({onClickCLoseWindow}:WindowOptionsProps) => {


  return (
    <div className={Styles.container} >
        <div className={classnames(Styles.button,Styles.close)} onClick={onClickCLoseWindow} ></div>
        <div className={classnames(Styles.button,Styles.resize)} onClick={()=>{}} ></div>
        <div className={classnames(Styles.button,Styles.minimize)} onClick={()=>{}} ></div>
    </div>
  )
}

export default WindowOptions
